import { FunctionComponent } from 'react'
import { Box, Typography, rucksack } from '@black-bear-energy/rucksack'

export const MenuButtonSection: FunctionComponent<MenuButtonSectionProps> = ({
  title,
  children,
}) => {
  return (
    <Box
      sx={{
        paddingX: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography
        variant="overline"
        sx={{
          letterSpacing: '0.0625em',
          color: rucksack.palette.text.secondary,
        }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  )
}

interface MenuButtonSectionProps {
  title: string
  children: React.ReactNode
}
